var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 23.082v.729M6.969 8.433c.194-1.94 1.746-5.82 6.399-5.82 6.987 0 9.315 8.73 2.91 11.64l-2.91 1.164v4.616",
    stroke: "#7D80DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgQuestion as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyNyAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMy4zNzUgMjMuMDgydi43MjlNNi45NjkgOC40MzNjLjE5NC0xLjk0IDEuNzQ2LTUuODIgNi4zOTktNS44MiA2Ljk4NyAwIDkuMzE1IDguNzMgMi45MSAxMS42NGwtMi45MSAxLjE2NHY0LjYxNiIgc3Ryb2tlPSIjN0Q4MERBIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";